module.exports = __webpack_public_path__ + "img/thank_icon.7303b01c.png";